module.exports = __webpack_public_path__ + "img/en2.4b2547e6.png";